export default {
      id: "money-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#money",
      toString: function () {
        return this.url;
      }
    }